import { Size } from 'types';
import { AddTextOverlayOptions } from '../modules/text/types';
import { updateState } from '../shared/mutations';
import { VideoTemplateStateContent } from '../types';

export function setAspectRatio(
  state: VideoTemplateStateContent,
  dimensions: Size<number> | number,
) {
  if (!dimensions) return state;

  const aspectRatio =
    typeof dimensions === 'number'
      ? dimensions
      : dimensions.width / dimensions.height;

  return {
    ...state,
    aspectRatio,
  };
}

export function updateSlideEffectText(
  state: VideoTemplateStateContent,
  id: string,
  text: string,
  opts?: AddTextOverlayOptions,
): VideoTemplateStateContent {
  return updateState(state, {
    slideEffectText: {
      [id]: { text, ...opts },
    },
  });
}
